<template>
    <div class="body">
        <v-header title="个人资料"></v-header>
        <div class="conH"></div>
        <div class="userinfo">
            <el-row :gutter="5">
            <el-col :xs="13" :sm="13" :md="13" :lg="13" :xl="13">
                <div class="grid-content bg-purple">
                    <div class="photo">
                        <img :src="src"/>
                    </div>
                    <div class="info">
                        <div class="item">
                            <label>姓名</label>
                            <span>{{user.psnName}}</span>
                        </div>
                        <div class="item">
                            <label>业务编码</label>
                            <span>{{user.pId}}</span>
                        </div>
                        <div class="item">
                            <label>性别</label>
                            <span>{{user.sexName}}</span>
                        </div>
                        <div class="item">
                            <label>生日</label>
                            <span>{{user.birthday|dateFormat}}</span>
                        </div>
                        <div class="item">
                            <label>学历</label>
                            <span>{{user.studyLevelName}}</span>
                        </div>
                         <div class="item">
                            <label>开户银行</label>
                            <span>{{user.bankName}}</span>
                        </div>

                        <div class="item">
                            <label>民族</label>
                            <span>{{user.nationName}}</span>
                        </div>
                        <div class="item">
                            <label>籍贯</label>
                            <span>{{user.pNative}}</span>
                        </div>
                        <div class="item">
                            <label>证件号</label>
                            <span>{{user.pCardId}}</span>
                        </div>
                        <div class="item">
                            <label>个人账号</label>
                            <span>{{user.accountNumber}}</span>
                        </div>
                        <div class="item">
                            <label>联系电话1</label>
                            <span>{{user.phone1}}</span>
                        </div>
                        <div class="item">
                            <label>联系电话2</label>
                            <span>{{user.phone2}}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
                <div class="grid-content bg-purple">
                    <div class="content">
                        <div class="item line">
                            <label>家庭住址</label>
                            <span>{{user.homeAddr}}</span>
                        </div>
                        <div class="item">
                            <label>入司时间</label>
                            <span>{{user.psnStartDate|dateFormat}}</span>
                        </div>
                        <div class="item">
                            <label>合同起始时间</label>
                            <span>{{user.contractStartDate|dateFormat}}</span>
                        </div>
                        <div class="item">
                            <label>合同终止时间</label>
                            <span>{{user.contractEndDate|dateFormat}}</span>
                        </div>
                        <!-- <div class="item arrow">
                            <label>合同类型</label>
                            <span>{{user.contractTypeName}}</span>
                            <i class="el-icon-arrow-right"></i>
                        </div> -->
                    </div>
                </div>
            </el-col>
        </el-row>
        </div>

    </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
import session from '@/components/cache'
export default {
  components: {
    vHeader
  },
  data () {
    return {
      loading: true,
      user: '',
      req: {
        pid: ''
      },
      src: 'http://111.160.216.85/eapp2/eapp-getFile/'
    }
  },
  filters: {
    dateFormat: function (value) {
      let str = value
      if (value === undefined) {
        return ''
      }
      return str.substr(0, 10)
    }
  },
  methods: {
    showContractPage () {
      console.log('-----')
    }
  },
  mounted () {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
      // target: document.querySelector('#getPolicyList')
    })
    let that = this
    this.req.pid = session.session_get('agentId')
    api.post(url.getPuserInfo, this.req, function (res) {
      that.user = res.data
      console.log(that.user)
      if (that.user.sexName === '女') {
        that.src = that.src + 'salm-' + that.user.pId + '.jpg'
      } else {
        that.src = that.src + 'sal-' + that.user.pId + '.jpg'
      }
    })
    loading.close()
  }
}
</script>

<style scoped>
.body{
    font-family:"Microsoft YaHei";
    font-size: 19px;
    /* background: #fff; */
    width:100%;
    min-height: 100%;
    overflow-x: hidden;
}
.userinfo{ width: 94%;margin: 0 auto;background: #fff; margin-top:2%;}
.item{
    width: 88%;
    height: auto;
    margin: 0 auto;
    line-height: 53px;
    border-bottom: 1px solid #f5f5f5;
    overflow: hidden;
}
.item.arrow{ position:relative;}
.item.arrow i{color:#D4D4D4; position:absolute; right:10px; top:50%; margin-top:-9px; cursor:pointer;}
.item.arrow span{color: #3D62AD;cursor:pointer;}
.line{
    line-height: 33px;
}
.photo{
    width:30%;
    float: left;
}
.photo img {
    float: right;
}
.info{
    width:70%;
    float: left;
}
label{
    float: left;
    display: block;
    width: 31%;
    color: #919191;
}

.userinfo span{
    float: left;
    display: block;
    width: 69%;
}
.el-col {
    border-radius: 4px;
}
.grid-content {
    border-radius: 4px;
    padding-top: 40px;
    min-height: 75vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/userinfo.vue